/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var TutorialsEditHomeIcon = createIcon("TutorialsEditHomeIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M79.5.5H.5v79h79V.5Z",
    fill: "#E1F4FF",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 25.5h-43a1 1 0 00-1 1v27a1 1 0 001 1h43a1 1 0 001-1v-27a1 1 0 00-1-1Z",
    fill: "#fff",
    stroke: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 32h-8a5 5 0 00-5 5v6a5 5 0 005 5h8a5 5 0 005-5v-6a5 5 0 00-5-5Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m44 40-6 3v-6l6 3Z",
    fill: "#fff"
  }));
}, {});